export type Currency = 'EUR' | 'USD';

export function fmtAmount(n: number, currency: Currency): string {
  const symbol = currency === 'USD' ? '$' : '€';
  const locale = currency === 'USD' ? 'en-US' : 'de-DE';
  return `${symbol}${new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n)}`;
}

export function currencySymbol(currency: Currency): string {
  return currency === 'USD' ? '$' : '€';
}
